import { post } from '@/utilities/onwardClient';
import { INTEGRATION_UPLOAD } from '@/constants/apiRoutes';

const START_UPLOAD_ERROR = 'Unable to start the JSON import. Please try again or contact support.';
const FILE_UPLOAD_ERROR = 'Unable to upload the JSON file. Please try again or contact support.';

export const uploadJson = async ({ shipperId, type, filename, jsonFile }) => {
    const resp = await post(INTEGRATION_UPLOAD, {
        type,
        shipperId,
        filename,
        patch: {},
    });

    const uploadUrl = resp?.data?.uploadUrl;
    if (!uploadUrl) {
        throw new Error(START_UPLOAD_ERROR);
    }

    const uploadMethod = resp?.data?.uploadMethod || 'PUT';
    // The upload endpoint dictates any headers the destination needs (e.g. the
    // emulator's `Authorization: Firebase owner` locally; none for a signed GCS
    // URL in deployed environments).
    const uploadHeaders = resp?.data?.uploadHeaders || {};
    let uploadResp;
    try {
        uploadResp = await fetch(uploadUrl, {
            method: uploadMethod,
            headers: uploadHeaders,
            body: typeof jsonFile === 'string' ? jsonFile : JSON.stringify(jsonFile),
        });
    } catch (err) {
        throw new Error(FILE_UPLOAD_ERROR);
    }

    if (!uploadResp.ok) {
        throw new Error(FILE_UPLOAD_ERROR);
    }

    return resp;
};
